import { formatDate} from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Company } from '../models/Compnany';
import { KaizenForecastAdj, KaizenForecastAdjLive } from '../models/Kaizen';
import { Line } from '../models/Line';
import { Shop } from '../models/Shop';
import { CompanyService } from '../Services/Company.Service';
import { KaizenService } from '../Services/Kaizen.Service';
import { LineService } from '../Services/Line.Services';
import { ShopService } from '../Services/Shop.Services';
import { firstValueFrom, finalize } from 'rxjs';
import { LoaderService } from '../loader/loader.service';

@Component({
    selector: 'app-forecastadjustments',
    templateUrl: './forecastadjustments.component.html',
    styleUrls: ['./forecastadjustments.component.css'],
    standalone: false
})
export class ForecastadjustmentsComponent implements OnInit {
  constructor(
    private CompanyService: CompanyService, private ShopService: ShopService, private kaizenService: KaizenService,
    private LineService: LineService, private fb: UntypedFormBuilder, private snackBar: MatSnackBar,
    private router: Router,public loaderService: LoaderService,
  ) { }

  companies!: Company[];
  filteredShops !: Shop[];
  filteredLines!: Line[];
  comapniesLoaded !: boolean;
  shopsLoaded !: boolean;
  linesLoaded !: boolean;
  formForecast!: UntypedFormGroup;
  kaizenForecastAdj: KaizenForecastAdj[] = [];
  kaizenForecastAdjLive: KaizenForecastAdjLive[] = [];


  public generated: boolean = false;
  public KaizenCombinedAry: any;
  public KaizenForecastAdjAry: any;
  public kaizenNumbers!: string;
  public updatedKaizenNumbers: number[] = [];

  ngOnInit(): void {
    this.getCompanies();
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    const fiscalYear = currentMonth >= 4 ? currentYear + 1 : currentYear;

    this.formForecast = this.fb.group({
      companyID: ['', Validators.required],
      lineId: [0, Validators.min(0)],
      shopId: [0, Validators.min(0)],
      finYear: [fiscalYear, Validators.min(1)],
      curDate: [new Date]
    });
    //---------->
    // this.generated = true;
    // this.getIniForecast(1, 1, 20, 2023, new Date('01/11/2022'));
    //--------------->
  }
  //getCompanies(): void { this.CompanyService.getCompanies().subscribdde(data => this.companies = data.data, error => console.log(error), () => this.comapniesLoaded = true) } 
  getCompanies(): void {
    this.CompanyService.getCompanies().subscribe({
      next: data => this.companies = data.data,
      error: error => console.log(error),
      complete: () => this.comapniesLoaded = true
    });
  }
  changeCompany(e: any) 
  { 
    firstValueFrom(this.LineService.getNonSupportLineByCompanyId(e.target.value)).then((data) => 
      { 
        this.filteredLines =data?.data || [] ;      
      });
  }
  changeLine(e: any) 
  { 
    firstValueFrom(this.ShopService.getNonSupportShopByLineId(e.target.value)).then((data) => 
      { 
        this.filteredShops =data?.data || [] ;      
      });
  }

  getIniForecast(
    CompanyID: number,
    lineId: number,
    shopId: number,
    finYear: number,
    curDate: Date
  ): void {
    this.loaderService.isLoading.next(true);

    this.kaizenService.getKaizenCombinedByFy(CompanyID, lineId, shopId, finYear)
      .pipe(
        finalize(() => this.loaderService.isLoading.next(false))
      )
      .subscribe({
        next: data => {
          this.KaizenCombinedAry = data?.data || [];

          for (let x = 0; x <= this.KaizenCombinedAry.length - 1; x++) {
            if (x == 0) {
              this.kaizenNumbers = this.KaizenCombinedAry[x].kaizenNumber;
            } else {
              this.kaizenNumbers += ',' + this.KaizenCombinedAry[x].kaizenNumber;
            }

            let _submittedOn = new Date(this.KaizenCombinedAry[x].submittedOn);
            let _implementationDate = new Date(this.KaizenCombinedAry[x].implementationDate);
            let _completiondate = new Date(this.KaizenCombinedAry[x].completionDate);

            if (_submittedOn >= new Date((finYear - 1) + '-01-01') && _submittedOn <= new Date((finYear - 1) + '-03-31')) {
              this.KaizenCombinedAry[x].q0F = true;
              this.KaizenCombinedAry[x].q1F = false;
              this.KaizenCombinedAry[x].q2F = false;
              this.KaizenCombinedAry[x].q3F = false;
              this.KaizenCombinedAry[x].initialBudget = 0;
              this.KaizenCombinedAry[x].updatedBudget = 0;
            }

            if (_submittedOn >= new Date((finYear - 1) + '-04-01') && _submittedOn <= new Date((finYear - 1) + '-05-31')) {
              this.KaizenCombinedAry[x].q0F = false;
              this.KaizenCombinedAry[x].q1F = true;
              this.KaizenCombinedAry[x].q2F = false;
              this.KaizenCombinedAry[x].q3F = false;
              this.KaizenCombinedAry[x].initialBudget = 1;
              this.KaizenCombinedAry[x].updatedBudget = 1;
            }

            if (_submittedOn >= new Date((finYear - 1) + '-06-01') && _submittedOn <= new Date((finYear - 1) + '-08-31')) {
              this.KaizenCombinedAry[x].q0F = false;
              this.KaizenCombinedAry[x].q1F = false;
              this.KaizenCombinedAry[x].q2F = true;
              this.KaizenCombinedAry[x].q3F = false;
              this.KaizenCombinedAry[x].initialBudget = 2;
              this.KaizenCombinedAry[x].updatedBudget = 2;
            }

            if (_submittedOn >= new Date((finYear - 1) + '-09-01') && _submittedOn <= new Date((finYear - 1) + '-12-31')) {
              this.KaizenCombinedAry[x].q0F = false;
              this.KaizenCombinedAry[x].q1F = false;
              this.KaizenCombinedAry[x].q2F = false;
              this.KaizenCombinedAry[x].q3F = true;
              this.KaizenCombinedAry[x].initialBudget = 3;
              this.KaizenCombinedAry[x].updatedBudget = 3;
            }

            if (this.KaizenCombinedAry[x].kaizenStateID == 10) {
              this.KaizenCombinedAry[x].actualImplementation = formatDate(this.KaizenCombinedAry[x].completionDate, 'MM/dd/yyyy', 'en-US');

              if (_completiondate < _implementationDate) {
                this.KaizenCombinedAry[x].forecastStatus = 'Pulled Ahead';
              } else {
                this.KaizenCombinedAry[x].forecastStatus = 'Completed';
              }
            } else if (this.KaizenCombinedAry[x].kaizenStateID == 9) {
              this.KaizenCombinedAry[x].actualImplementation = 'Cancelled';
              this.KaizenCombinedAry[x].forecastStatus = 'Cancelled';
            } else {
              this.KaizenCombinedAry[x].actualImplementation = 'In Progress';

              if (new Date(curDate) < _implementationDate) {
                this.KaizenCombinedAry[x].forecastStatus = 'On Time';
              } else {
                this.KaizenCombinedAry[x].forecastStatus = 'Past Due';
              }
            }
          }

          this.kaizenService.getForecastAdjByKaizenNumbers(this.kaizenNumbers).subscribe({
            next: data => {
              this.KaizenForecastAdjAry = data.data;

              for (let x = 0; x <= this.KaizenCombinedAry.length - 1; x++) {
                for (let y = 0; y <= this.KaizenForecastAdjAry.length - 1; y++) {
                  if (this.KaizenForecastAdjAry[y].kaizenNumber == this.KaizenCombinedAry[x].kaizenNumber) {
                    this.updatedKaizenNumbers.push(this.KaizenForecastAdjAry[y].kaizenNumber);
                    this.KaizenCombinedAry[x].q0F = false;
                    this.KaizenCombinedAry[x].q1F = false;
                    this.KaizenCombinedAry[x].q2F = false;
                    this.KaizenCombinedAry[x].q3F = false;

                    this.KaizenCombinedAry[x].q0F = this.KaizenForecastAdjAry[y].originalBudget;
                    this.KaizenCombinedAry[x].q1F = this.KaizenForecastAdjAry[y].q1F;
                    this.KaizenCombinedAry[x].q2F = this.KaizenForecastAdjAry[y].q2F;
                    this.KaizenCombinedAry[x].q3F = this.KaizenForecastAdjAry[y].q3F;

                    this.KaizenCombinedAry[x].updatedBudget = -1;
                    if (this.KaizenForecastAdjAry[y].originalBudget) {
                      this.KaizenCombinedAry[x].updatedBudget = 0;
                    }
                    if (this.KaizenForecastAdjAry[y].q1F) {
                      this.KaizenCombinedAry[x].updatedBudget = 1;
                    }
                    if (this.KaizenForecastAdjAry[y].q2F) {
                      this.KaizenCombinedAry[x].updatedBudget = 2;
                    }
                    if (this.KaizenForecastAdjAry[y].q3F) {
                      this.KaizenCombinedAry[x].updatedBudget = 3;
                    }
                  }
                }
              }
            },
            error: err => console.error(err)
          });
        },
        error: err => console.error(err)
      });
  }
  onSubmit() {
    if (this.formForecast.valid) {
      this.getIniForecast(this.formForecast.value.companyID, this.formForecast.value.lineId, this.formForecast.value.shopId, this.formForecast.value.finYear, this.formForecast.value.curDate);
      this.generated = true;
    }
  }

  changeBudget(kaizenNumber: number, e: any, ctrlName: string) {
    var forecastStatus = e.target.checked;
    this.updateBudget(kaizenNumber, ctrlName, forecastStatus);
  }

  updateBudget(kaizenNumber: number, ctrlName: string, forecastStatus: boolean) {
    this.updatedKaizenNumbers.push(kaizenNumber);
    for (let x = 0; x <= this.KaizenCombinedAry.length - 1; x++) {
      if (this.KaizenCombinedAry[x].kaizenNumber == kaizenNumber) {
        this.KaizenCombinedAry[x].forecastAdjLive = false;
        this.KaizenCombinedAry[x].q0F = false;
        this.KaizenCombinedAry[x].q1F = false;
        this.KaizenCombinedAry[x].q2F = false;
        this.KaizenCombinedAry[x].q3F = false;

        if (ctrlName == 'q0F') {
          this.KaizenCombinedAry[x].q0F = forecastStatus;
          if(forecastStatus){
          this.KaizenCombinedAry[x].updatedBudget = 0;
          }
          else{
            this.KaizenCombinedAry[x].updatedBudget = -1;
          }
        }
        else if (ctrlName == 'q1F') {
          this.KaizenCombinedAry[x].q1F = forecastStatus;
          if(forecastStatus){
            this.KaizenCombinedAry[x].updatedBudget = 1;
            }
            else{
              this.KaizenCombinedAry[x].updatedBudget = -1;
            }
        }
        else if (ctrlName == 'q2F') {
          this.KaizenCombinedAry[x].q2F = forecastStatus;
          if(forecastStatus){
            this.KaizenCombinedAry[x].updatedBudget = 2;
            }
            else{
              this.KaizenCombinedAry[x].updatedBudget = -1;
            }
        }
        else if (ctrlName == 'q3F') {
          this.KaizenCombinedAry[x].q3F = forecastStatus;
          if(forecastStatus){
            this.KaizenCombinedAry[x].updatedBudget = 3;
            }
            else{
              this.KaizenCombinedAry[x].updatedBudget = -1;
            }
        }
        else if (ctrlName == 'forecastAdjLive') {
          this.KaizenCombinedAry[x].forecastAdjLive = forecastStatus;
          if(forecastStatus){
            this.KaizenCombinedAry[x].updatedBudget = 4;
            }
            else{
              this.KaizenCombinedAry[x].updatedBudget = -1;
            }
        }
      }
    }
  }

  saveForecast() {
    for (let x = 0; x <= this.KaizenCombinedAry.length - 1; x++) {
      const fcastitem: KaizenForecastAdj = {
        kaizenNumber: this.KaizenCombinedAry[x].kaizenNumber,
        originalBudget: this.KaizenCombinedAry[x].q0F,
        q1F: this.KaizenCombinedAry[x].q1F,
        q2F: this.KaizenCombinedAry[x].q2F,
        q3F: this.KaizenCombinedAry[x].q3F,
        createdBy: localStorage.getItem('ademail')!,
        createdOn: new Date,
        kaizenForecastAdjustmentID: 0,
        modifiedBy: localStorage.getItem('ademail')!,
        modifiedOn: new Date
      }
      const fcastAdjLiveItem: KaizenForecastAdjLive = {
        kaizenId: this.KaizenCombinedAry[x].kaizenNumber,
        forecastAdjLive: this.KaizenCombinedAry[x].forecastAdjLive
      }

      if (this.updatedKaizenNumbers.includes(fcastitem.kaizenNumber)) {
        this.kaizenForecastAdj.push(fcastitem);
        this.kaizenForecastAdjLive.push(fcastAdjLiveItem);
      }
     // this.kaizenForecastAdj.push(fcastitem);
    }
    this.kaizenService.postForecastAdj(this.kaizenForecastAdj).subscribe();
    this.kaizenService.updateKaizenForecastAdjLive(this.kaizenForecastAdjLive).subscribe();
   // this.snackBar.open("Kaizen Forecast Adjustment saved Successfully!");
    // setTimeout(() => {
    //   this.snackBar.dismiss();
    // }, 2000);
    this.router.navigate(['./kaizens']);

  }

  showDetails(kaizenNumber: number) {
    this.router.navigate(['kaizenDetails/' + kaizenNumber]);
  }
  cancel() {
    this.generated = false;
  }

}